<template>
  <v-btn outlined :disabled="!isFiltered" :color="'error'" small @click="clearFilters()">
    <!--<v-icon size="14" class="mr-1">mdi-filter-off</v-icon>-->
    {{ $t("servicesystem.common_objects.commonterms.clear") }}
  </v-btn>

  <!--
  <v-btn icon :disabled="!isFiltered" :color="'error'" class="ma-3 mb-n3" @click="clearFilters()">
    <v-icon size="14" class="mr-1">mdi-filter-off</v-icon>
  </v-btn>
    -->
</template>


<script>
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";

export default {
  name: 'ClearFiltersBtn',
  props: {
    pk: String,
  },
  components: {},
  mixins: [FilterQueryMixin],

  data() {
    return {
      cleartrigger: 1,
    };
  },

  mounted() {
    if (this.$route.query.resetkey != undefined) {
      var currentQuery = Object.assign({}, this.$route.query);
      currentQuery.resetkey = undefined;
      this.$router.replace({ query: currentQuery });
    }
  },

  methods: {
    clearFilters() {
      var key = this.pk + 'filter';
      var query = Object.assign({}, this.$route.query);
      //remove all filter keys that have the pk in them
      query = Object.keys(query)
        .filter(objKey => !objKey.includes(key))
        .reduce((newObj, key) => { newObj[key] = query[key]; return newObj; }, {});
      //add back the reset key and tab state
      query = {
        ...query,
        [key]: this.$route.query[key],
        [this.pk + 'resetkey']: this.cleartrigger
      }
      this.$router.replace({ query });
      this.cleartrigger++;
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>